import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapPickerComponent } from './map-picker.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    MapPickerComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    MapPickerComponent
  ]
})
export class MapPickerModule { }
